<div class="row row-cols-2 row-cols-sm-3 row-cols-lg-5 g-3 pb-2">
  @for (kpiCard of kpiCardOrder; track kpiCard) {
    <div>
      <mat-card appearance="outlined" class="kpi-card h-100" [class.is-selected]="selectedKpiCard === kpiCard">
        <button
          matRipple
          type="button"
          class="kpi-card-button"
          [attr.aria-pressed]="selectedKpiCard === kpiCard"
          (click)="selectKpiCard(kpiCard)"
        >
          <span class="kpi-card-header">
            <span class="kpi-card-icon" [ngClass]="kpiCardDetails[kpiCard].iconClass">
              <mat-icon aria-hidden="true">{{ kpiCardDetails[kpiCard].icon }}</mat-icon>
            </span>
            <span class="kpi-card-title">{{ kpiCardDetails[kpiCard].title }}</span>
          </span>

          <span class="kpi-card-body">
            <span class="kpi-card-value">{{ kpiCardDetails[kpiCard].count }}</span>
            <span class="kpi-card-breakdown">
              @for (breakdown of kpiCardDetails[kpiCard].breakdown; track breakdown.key) {
                <span class="kpi-card-breakdown-item">
                  <span class="kpi-card-dot" [ngClass]="breakdown.barClass" aria-hidden="true"></span>
                  <span class="kpi-card-breakdown-title">{{ breakdown.title }}</span>
                  <span class="kpi-card-breakdown-count">{{ breakdown.count }}</span>
                </span>
              }
            </span>
          </span>

          <span class="kpi-card-track" aria-hidden="true">
            @for (breakdown of kpiCardDetails[kpiCard].breakdown; track breakdown.key) {
              <span class="kpi-card-track-fill" [ngClass]="breakdown.barClass" [style.width.%]="breakdown.share"></span>
            }
          </span>
        </button>
      </mat-card>
    </div>
  }
</div>
